(function () {
  const MOBILE_QUERY = window.matchMedia("(max-width: 767px)");

  function initCarousel(section) {
    const carousel = section.querySelector(".find-our-store__bg-carousel--autoplay");
    if (!carousel || carousel.dataset.fosCarouselBound === "true") return;

    const slides = [...carousel.querySelectorAll(".find-our-store__bg-slide")];
    if (slides.length <= 1) return;

    carousel.dataset.fosCarouselBound = "true";

    let index = slides.findIndex((slide) => slide.classList.contains("is-active"));
    if (index < 0) index = 0;

    let timer = null;
    const ms = parseInt(section.dataset.mobileAutoplayMs, 10) || 5000;

    function show(nextIndex) {
      slides.forEach((slide, i) => {
        slide.classList.toggle("is-active", i === nextIndex);
      });
      index = nextIndex;
    }

    function next() {
      show((index + 1) % slides.length);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!MOBILE_QUERY.matches || document.hidden) return;
      timer = setInterval(next, ms);
    }

    MOBILE_QUERY.addEventListener("change", start);
    document.addEventListener("visibilitychange", start);
    window.addEventListener("pagehide", stop);

    show(index);
    start();

    section._fosCarouselStop = stop;
  }

  function destroyCarousel(section) {
    section._fosCarouselStop?.();
    section._fosCarouselStop = null;

    const carousel = section.querySelector(".find-our-store__bg-carousel");
    if (carousel) {
      delete carousel.dataset.fosCarouselBound;
    }
  }

  function initSection(section) {
    if (!section?.classList.contains("find-our-store")) return;
    destroyCarousel(section);
    initCarousel(section);
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll(".find-our-store.section-find-our-store")
      .forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(".find-our-store.section-find-our-store");
    if (section) initSection(section);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target.querySelector(".find-our-store.section-find-our-store");
    if (section) destroyCarousel(section);
  });
})();
